import "./DentalPlaqueCleaning.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import InformationAndNavigation from "./sections/InformationAndNavigation";
import SubscriptionBenefits from "./sections/SubscriptionBenefits";
import ContactPageOverview from "./sections/ContactPageOverview";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function DentalPlaqueCleaningPage() {
  return <div>
      <Header />
      <HeroBanner />
      <InformationAndNavigation />
      <SubscriptionBenefits />
      <ContactPageOverview />
      <Projects />
      <Footer />
    </div>;
}